// What the dots mean.
//
// One dot that means "something happened" is a shrug: you open the drawer,
// scan four sections, and hunt. Colour tells you which of them moved before
// you have opened anything, and the SAME colour appears on the tab inside,
// so the corner dot and the tab agree without anybody explaining the code.
//
// Four is the ceiling, and it got there reluctantly: mentions earned the
// fourth slot because "he said something about you" is the one event
// people will come back for, and folding it into "you" would light the
// wrong tab. A fifth colour and this stops being a glance and starts
// being a legend.

export const NOTICE = {
  // He read something you left, and decided.
  offerings: { color: '#e0743c', label: 'an offering was judged' },
  // The town is deciding something, or something you were part of moved.
  calendar: { color: '#5a8fd6', label: 'something is happening in the town' },
  // Your standing moved. Yellow because it is good news rather than an
  // errand: nothing needs doing, it is worth knowing.
  you: { color: '#e8c04a', label: 'your standing with him moved' },
  // He said your name: a verdict, a letter, a deed of yours he found.
  mentions: { color: '#a78bfa', label: 'he mentioned you' },
}

/** The kinds currently lit, in a fixed order so the dots never reshuffle. */
export function activeNotices(notices) {
  return ['you', 'mentions', 'offerings', 'calendar'].filter((k) => notices?.[k])
}

/**
 * What the profile surface is lit for, computed ONCE.
 *
 * This existed twice: the corner button folded the shrine's unseen
 * verdicts into the offerings dot, while the drawer's tabs read the raw
 * flag. So a dot could sit on the corner with no tab claiming it, which
 * is precisely the "which tab is this about?" that Sam hit. Both sides
 * call this now, so they cannot disagree.
 *
 * Offerings fold into MENTIONS because the tabs merged: everything he has
 * done about you (a verdict, an email, a deed of yours he found) is one
 * timeline with a type pill, not three places to check.
 */
export function profileNotices({ notices = {}, shrineUnseen = false } = {}) {
  return {
    you: !!notices.you,
    mentions: !!(notices.mentions || notices.offerings || shrineUnseen),
  }
}
